export default __webpack_public_path__ + "assets/image_widget.12e78e6752d2937944bcb4e5ea3226ef.svg";